var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeertube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 682.68799,
    viewBox: "2799 -911 512 682.688",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2799-911v341.344l256-170.656",
    fill: "#211f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2799-569.656v341.344l256-170.656",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3055-740.344v341.344l256-170.656",
    fill: "#f1680d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeertube);
export default __webpack_public_path__ + "static/media/peertube.69a1b486c0476aaec98d6b4371c26d2b.svg";
export { ForwardRef as ReactComponent };